module.exports = __webpack_public_path__ + "img/15-2.b1f62d47.png";